import { POIAlertReportOutputData } from './poi-alert-report-output-data.model';


export class POIAlertReportOutput implements IPOIAlertReportOutput {
    status!: number;
    message!: string;
    data!: POIAlertReportOutputData;

    constructor(data?: IPOIAlertReportOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.message = _data["message"];
            this.data = _data["data"] ? POIAlertReportOutputData.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): POIAlertReportOutput {
        data = typeof data === 'object' ? data : {};
        let result = new POIAlertReportOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["message"] = this.message;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IPOIAlertReportOutput {
    status: number;
    message: string;
    data: POIAlertReportOutputData;
}

